import NamedDto from 'modules/base/dto/NamedDto';

export default class MeasurementUnitTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
	}

	/**
	 * @typedef {Object} _MeasurementUnitTableDtoProps
	 * @property {Date} created
	 * @property {Date} updated
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _MeasurementUnitTableDtoProps} MeasurementUnitTableDtoProps
	 */
	/**
	 *
	 * @param {MeasurementUnitTableDtoProps} props
	 * @returns {MeasurementUnitTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.created = props.created != null ? new Date(props.created) : null;
		this.updated = props.updated != null ? new Date(props.updated) : null;
		return this;
	}
}
